import React from 'react'
import UserProfileModal from '../profile-modal'
import useClientLocation from '../../../hooks/use-client-location'
import UserCreateModal from '../create-modal'

const UserProfileScreen = () => {
    const { params, goBack } = useClientLocation()
    const userId = params.userId

    if (userId === 'new') {
        return ( <UserCreateModal onHide={goBack} /> )
    }

    return ( <UserProfileModal userId={params.userId} onHide={goBack} /> )
}

export default UserProfileScreen